import { createPutRequest, ignoreJsonError } from '../../request/request-utils'

const request = createPutRequest(process.env.REACT_APP_ELEARN_URL || '/')

export function resetStudentLesson(studentEmail: string, lessonId: string) {
  return request<any>(`/teacher/lesson-reset/${lessonId}/${studentEmail}`)
}

